import Types from '../Types';
import Immutable from 'seamless-immutable';
import { createReducer } from 'reduxsauce';
import _get from 'lodash.get';

export const INITIAL_STATE = Immutable({
  error: null,
  findAttempting: false, bannerMap: {},
  saveAttempting: {},
  removeAttempting: {}
});

const ACTION_HANDLERS = {
  [Types.FIND_BANNERS_ATTEMPT]: (state, action) =>
    state.merge({ findAttempting: true }),
  [Types.FIND_BANNERS_SUCCESS]: (state, action) =>
    state.merge({
      findAttempting: false,
      bannerMap: (action.result || []).reduce((map, banner) => ({ ...map, [banner.bannerKey]: banner }), {}),
      error: null
    }),
  [Types.FIND_BANNERS_FAILURE]: (state, action) =>
    state.merge({ findAttempting: false, error: action.error }),

  [Types.SAVE_BANNER_ATTEMPT]: (state, action) =>
    state.merge({ saveAttempting: state.saveAttempting.merge({ [_get(action, ['options', 'bannerKey'])]: true }) }),
  [Types.SAVE_BANNER_SUCCESS]: (state, action) =>
    state.merge({
      saveAttempting: state.saveAttempting.merge({ [action.result.bannerKey]: false }),
      bannerMap: state.bannerMap.merge({ [action.result.bannerKey]: action.result }),
      error: null
    }),
  [Types.SAVE_BANNER_FAILURE]: (state, action) =>
    state.merge({ saveAttempting: state.saveAttempting.merge({ [action.result.bannerKey]: false, error: action.error }) }),

  [Types.REMOVE_BANNER_ATTEMPT]: (state, action) =>
    state.merge({ removeAttempting: state.removeAttempting.merge({ [_get(action, ['options', 'bannerKey'])]: true }) }),
  [Types.REMOVE_BANNER_SUCCESS]: (state, action) =>
    state.merge({
      removeAttempting: state.removeAttempting.merge({ [action.result.bannerKey]: false }),
      bannerMap: state.bannerMap.merge({ [action.result.bannerKey]: undefined }),
      error: null
    }),
  [Types.REMOVE_BANNER_FAILURE]: (state, action) =>
    state.merge({ removeAttempting: state.removeAttempting.merge({ [action.result.bannerKey]: false }), error: action.error })
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/redux/banner/bannerReducer.js